import { type inferRouterInputs, type inferRouterOutputs } from '@trpc/server';

import type { AppRouter } from '../../../apps/server/src/router';

export type RouterOutputs = inferRouterOutputs<AppRouter>;
export type RouterInputs = inferRouterInputs<AppRouter>;

/**
 * Get cookie prefix from environment variable
 * Defaults to 'ft' if not set
 */
const getCookiePrefix = (): string => {
  // Check all possible environment variable formats
  const prefix =
    process.env.COOKIE_PREFIX ||
    process.env.NEXT_PUBLIC_COOKIE_PREFIX ||
    process.env.EXPO_PUBLIC_COOKIE_PREFIX ||
    'ft';
  return prefix;
};

export const STORAGE_KEYS = {
  AUTH_TOKEN: `${getCookiePrefix()}-auth`,
  CLIENT_TOKEN: `${getCookiePrefix()}-client`,
  // Device-level Expo push token cache. Kept across logout/deauth: it identifies
  // the device, and sign-in sends it so the server never rings the requester.
  PUSH_TOKEN: 'expoPushToken'
};

export type JwtPayload = {
  id: number;
  userId: number;
  verifiedHumanAt: Date | null;
  sessions?: number[];
  exp: number;
};
